
const switchUserDataArray = JSON.parse(localStorage.getItem('switchUserData'));
const switchedActiveUserTemp = JSON.parse(localStorage.getItem('switchedActiveUser'));

const initialState = { switchUserData: (switchUserDataArray) ? switchUserDataArray : [], switchedActiveUser: (switchedActiveUserTemp) ? switchedActiveUserTemp : [] };
export const swithUser = {
    namespaced: true,
    state: initialState,
    actions: {
        addUserInfo({ commit }, userInfo) {

            commit('updateSwitchUserDataState', userInfo);
            commit('setActiveUserState');
        },
        resetSwitchUserData({ commit }) {
            commit('resetSwitchUserDataState');
            commit('setActiveUserState');
        },
        removeSwitchUser({ commit }, userInfo) {
            commit('removeSwitchUserState', userInfo);
            commit('setActiveUserState');
        },
        setActiveUser({ commit }) {
            commit('setActiveUserState');
        }
    },
    mutations: {
        updateSwitchUserDataState(state, userInfo) {
            state.switchUserData.push(userInfo);
            localStorage.setItem('switchUserData', JSON.stringify(state.switchUserData));

        },
        resetSwitchUserDataState(state) {
            state.switchUserData = [];
            localStorage.removeItem("switchUserData");
        },
        removeSwitchUserState(state, userInfo) {
            let index = state.switchUserData.findIndex(x => x.email === userInfo.email);
            state.switchUserData.length = index + 1;
            localStorage.setItem('switchUserData', JSON.stringify(state.switchUserData));
        },
        setActiveUserState(state,) {

            state.switchedActiveUser = [];
            localStorage.removeItem('switchedActiveUser');
            if (state.switchUserData.length) {
                //code to get last user detail from array
                let activeUser = state.switchUserData[state.switchUserData.length - 1];
                state.switchedActiveUser.push(activeUser);
                localStorage.setItem('switchedActiveUser', JSON.stringify(state.switchedActiveUser));

            }


        },

    },
    getters: {
        getStateAuth(state, _, rootState) {
            // console.log('yes here')
            // console.log(rootState.auth.user)
            return rootState.auth.user;
        },
    }
};